import { FETCH_ACTIVITY_LOG, LOADING } from "actions/types";
import advisorhq from "apis/advisorhq";

export const fetchActivityLog = caseId => async (dispatch, getState) => {
  dispatch({ type: LOADING, payload: { activityLog: true } });
  const response = await advisorhq.get(`/comm/api/get_activity_log/${caseId}/`);
  dispatch({ type: FETCH_ACTIVITY_LOG, payload: response.data });
  dispatch({ type: LOADING, payload: { activityLog: false } });
};
